import { hasEmptyValue, hasValue } from 'Lib/Any';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../Data/ReduxViewModels/Admin';
import { Button, Checkbox, EmailInput, Field, Message, NumericInput, PasswordInput, TextInput } from '../Core';
import { FieldSet, ListFieldSection, PageSection } from '../Layout';

const SmtpSection = () => {
  const useDefaultCredentials = useSelector((state) => state.admin.syncModel.SmtpSettings?.DefaultCredentials);
  const isPortSet = useSelector((state) => hasValue(state.admin.syncModel.SmtpSettings?.Port));

  return (
    <ListFieldSection single>
      <Field label="Fallback From Address" input={<EmailInput />} name={`syncModel.SmtpSettings.From`} />
      <Field label="Hostname" input={<TextInput />} name={`syncModel.SmtpSettings..Host`} />
      <Field
        label="Port"
        input={<NumericInput />}
        name={`syncModel.SmtpSettings.Port`}
        messages={!isPortSet ? [{ message: 'Port cannot be null', severity: 'error' }] : null}
      />
      <Field label="Use TLS" input={<Checkbox />} name={`syncModel.SmtpSettings.EnableSsl`} />
      <FieldSet>
        <Field
          label="Use default user credentials"
          input={<Checkbox />}
          name={`syncModel.SmtpSettings.DefaultCredentials`}
        />
        {!useDefaultCredentials && (
          <>
            <Field label="Username" input={<TextInput />} name={`syncModel.SmtpSettings.Username`} />
            <Field
              onCopy="return false"
              label="Password"
              input={<PasswordInput />}
              name={`syncModel.SmtpSettings.Password`}
            />
          </>
        )}
      </FieldSet>
    </ListFieldSection>
  );
};

const AdditionalSettingSection = () => (
  <ListFieldSection wide>
    <Message
      severity="info"
      message="Any configured data integrators which specify their own email settings will not be affected by these settings."
    />
    <Field
      label="Send email from SMTP fallback address instead of sender address"
      input={<Checkbox />}
      name={`syncModel.SendEmailFromFallbackAddress`}
    />
    <Field label="Set reply-to as sender address" input={<Checkbox />} name={`syncModel.SetReplyToAsSender`} />
  </ListFieldSection>
);

const TestSection = () => {
  const dispatch = useDispatch();
  const [address, setAddress] = useState('');
  const startTest = () => {
    dispatch(actions.testEmailSettings({ address }));
  };
  const testing = useSelector((state) => state.admin.emailTest.testing);
  const success = useSelector((state) => state.admin.emailTest.success);
  const errorMessage = useSelector((state) => state.admin.emailTest.error);
  const syncing = useSelector((state) => state.admin.status.syncing);

  let testMessages = [];
  if (testing) {
    testMessages.push({ message: 'Sending test email...', severity: 'info' });
  }
  if (success) {
    testMessages.push({ message: 'Test was successful', severity: 'success' });
  }
  if (errorMessage) {
    testMessages.push({ message: errorMessage, severity: 'error' });
  }

  return (
    <ListFieldSection single>
      <Field
        label="Send To"
        input={<EmailInput />}
        onChange={(e) => setAddress(e.data.value)}
        messages={testMessages}
        value={address}
      />
      <Button loading={testing} onClick={() => startTest()} primary disabled={hasEmptyValue(address) || syncing}>
        Send Test Email
      </Button>
    </ListFieldSection>
  );
};

const EmailAdmin = () => (
  <>
    <PageSection heading="SMTP Settings">
      <SmtpSection />
    </PageSection>
    <PageSection heading="Additional Settings">
      <AdditionalSettingSection />
    </PageSection>
    <PageSection heading="Test Email">
      <TestSection />
    </PageSection>
  </>
);

export default EmailAdmin;
export { EmailAdmin };
